// src/components/statusHistory.js

import axios from "axios";

/* =========================================================
   GET MY ACTIVE STATUSES
========================================================= */
export async function getMyStatuses() {

  try {

    const res = await axios.get(
      "/api/status/mine",
      {
        withCredentials: true,
      }
    );

    return res.data;

  } catch (error) {

    const status =
      error?.response?.status;

    if (
      status !== 401 &&
      status !== 403
    ) {

      console.error(
        "[STATUS] Failed to load my statuses",
        error
      );

    }

    throw error;

  }

}

/* =========================================================
   GET FOLLOWING ACTIVE STATUSES
========================================================= */
export async function getFollowingStatuses() {

  try {

    const res = await axios.get(
      "/api/status/following",
      {
        withCredentials: true,
      }
    );

    return res.data;

  } catch (error) {

    const status =
      error?.response?.status;

    if (
      status !== 401 &&
      status !== 403
    ) {

      console.error(
        "[STATUS] Failed to load following statuses",
        error
      );

    }

    throw error;

  }

}

/* =========================================================
   GET STATUS VIEWERS
========================================================= */
export async function getStatusViewers(
  statusId
) {

  try {

    const res = await axios.get(
      `/api/status/${statusId}/views`,
      {
        withCredentials: true,
      }
    );

    return res.data;

  } catch (error) {

    const status =
      error?.response?.status;

    if (
      status !== 401 &&
      status !== 403
    ) {

      console.error(
        "[STATUS] Failed to load status viewers",
        error
      );

    }

    throw error;

  }

}